import React, {useEffect, useState} from "react";
import {DELETE_PLANNER, PLANNERS_URL, SAVE_PLANNER, USERS_PLANNER_URL,} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import {Grid, IconButton, TextField, Typography} from "@mui/material";
import SearchableDropDown from "@Components/DropDown/SearchableDropDown";
import Joi from "joi";
import {
    NameValidation,
    OptionalDropDownValidation
} from "@Utils/Validations/UserValidations/UserValidationFieldsSchema";
import useGetAll from "@Hooks/useGetAll";
import {submitFormWithValidation, validateField} from "@Utils/Validations/HelperFunctions/FormValidationFunctions";

function PlannersListing() {
    const attributes = [
        {key: "plannerName", label: "Planner Name", flex: 2},
        {key: "userEmail", label: "User Email", flex: 2},
    ];

    const [isEnabled, setIsEnabled] = useState(false);

    const [userNameOptions, setuserNameOptions] = useState([]);
   const initialState = {
        plannerName: "",
        userId: "",
   }
    const [newPlannerData, setnewPlannerData] = useState(initialState);

    const [ids, setIds] = useState([]);
    const validationSchema = Joi.object({
        plannerName: NameValidation("Planner Name"),
        userId: OptionalDropDownValidation("User Planner Email", ids),
    });

    const {getAll} = useGetAll();
    useEffect(() => {
        getAll(USERS_PLANNER_URL, `Failed to fetch User Planners`)
            .then((fetchedData) => {
                setuserNameOptions([
                    ...fetchedData.map((item) => ({
                        id: item.id,
                        name: item.plannerEmail,
                    })),
                ]);
                const userIds = fetchedData.map((item) => item.id);
                setIds(userIds);
            })
            .catch((error) => console.error(error));
    }, []);


    const [errors, setErrors] = useState({});
    const clearData = () => {
        setnewPlannerData(initialState);
        setErrors({});
    }
    // Handle form submission
    const handleOnSubmit = async () => {
        return submitFormWithValidation(newPlannerData, !isEnabled, "userId", setErrors, validationSchema);
    };
    const toggelVisabiltyForPlannerEmail = async (state) => {
        setIsEnabled(state);
        if (state)
            setnewPlannerData({...newPlannerData, userId: ""});
    };


    const handleOnBlur = async (field, value) => {
        validateField(field, value, setnewPlannerData, newPlannerData, validationSchema, setErrors);
    };

    const form = (
        <>
            {
                <form onSubmit={handleOnSubmit} className="formWrapper">
                    <Grid
                        className="inputContainer"
                        container
                        spacing={2}
                        justifyContent="flex-end"
                    >
                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{mb: 1}}>
                                Planner Name
                            </Typography>
                            <TextField
                                onBlur={(e) => handleOnBlur("plannerName", e.target.value)}
                                value={newPlannerData.plannerName || ""}
                                onChange={(e) => {
                                    setnewPlannerData({
                                        ...newPlannerData,
                                        plannerName: e.target.value,
                                    });
                                    setErrors({...errors, plannerName: ""}); // Clear error message on input change
                                }}
                                variant="outlined"
                                placeholder="Planner Name"
                                fullWidth
                                helperText={errors.plannerName} // Show validation error message
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2=3" sx={{mb: 1}}>
                                User Planner Email
                                <IconButton
                                    onClick={() => toggelVisabiltyForPlannerEmail(!isEnabled)}
                                >
                                    {isEnabled ? (
                                        <ToggleOnIcon color="primary"/>
                                    ) : (
                                        <ToggleOffIcon color="disabled"/>
                                    )}
                                </IconButton>
                            </Typography>

                            {isEnabled && (
                                <SearchableDropDown
                                    state={newPlannerData.userId}
                                    setState={(value) => {
                                        setnewPlannerData({...newPlannerData, userId: value});
                                        setErrors({...errors, userId: ""});
                                    }}
                                    name="userId"
                                    label=""
                                    items={userNameOptions}
                                    placeholder="Select a User Planner Email"
                                    helperText={errors.userId}
                                />
                            )}

                        </Grid>
                    </Grid>
                </form>
            }
        </>
    );

    return (
        <GenericItemsListing
            items_URL={PLANNERS_URL}
            SAVE_Item={SAVE_PLANNER}
            DELETE_Item={DELETE_PLANNER}
            title="Planners"
            name="Planner"
            icon={<AssignmentIndIcon fontSize="large" color="white"/>}
            attributes={attributes}
            customFormForAddtion={{formContent: form, formButton: handleOnSubmit}}
            uniqueId={"plannerId"}
            clearData={clearData}
            isClearancePlanner={true}
        />
    );
}

export default PlannersListing;
